import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الوزن الجزيئي";
const DESCRIPTION =
  "استخدم حاسبة الوزن الجزيئي لحساب الوزن الجزيئي لأي مركب كيميائي بسهولة. أدخل العناصر الكيميائية التي يتكون منها المركب لحساب الوزن الجزيئي بدقة.";
const KEYWORDS =
  "حاسبة الوزن الجزيئي, حساب الوزن الجزيئي, الوزن الذري, الجدول الدوري, الكيمياء, الكتلة المولية, حاسبة الكيمياء";
const OG_URL =
  "https://do-calculate.com/calculator/ar/molecular-weight-calculator/";
const ELEMENTS = {
  H: 1.008,
  He: 4.0026,
  Li: 6.94,
  Be: 9.0122,
  B: 10.81,
  C: 12.011,
  N: 14.007,
  O: 15.999,
  F: 18.998,
  Ne: 20.18,
  Na: 22.99,
  Mg: 24.305,
  Al: 26.982,
  Si: 28.085,
  P: 30.974,
  S: 32.06,
  Cl: 35.45,
  Ar: 39.948,
  K: 39.098,
  Ca: 40.078,
  Sc: 44.956,
  Ti: 47.867,
  V: 50.942,
  Cr: 51.996,
  Mn: 54.938,
  Fe: 55.845,
  Co: 58.933,
  Ni: 58.693,
  Cu: 63.546,
  Zn: 65.39,
  Ga: 69.723,
  Ge: 72.64,
  As: 74.922,
  Se: 78.96,
  Br: 79.904,
  Kr: 83.798,
  Rb: 85.468,
  Sr: 87.62,
  Y: 88.906,
  Zr: 91.224,
  Nb: 92.906,
  Mo: 95.94,
  Tc: 98.907,
  Ru: 101.07,
  Rh: 102.906,
  Pd: 106.42,
  Ag: 107.868,
  Cd: 112.414,
  In: 114.818,
  Sn: 118.71,
  Sb: 121.76,
  Te: 127.6,
  I: 126.905,
  Xe: 131.293,
  Cs: 132.906,
  Ba: 137.327,
  La: 138.906,
  Ce: 140.116,
  Pr: 140.908,
  Nd: 144.242,
  Pm: 144.913,
  Sm: 150.36,
  Eu: 151.964,
  Gd: 157.25,
  Tb: 158.925,
  Dy: 162.5,
  Ho: 164.93,
  Er: 167.259,
  Tm: 168.934,
  Yb: 173.04,
  Lu: 174.967,
  Hf: 178.49,
  Ta: 180.948,
  W: 183.84,
  Re: 186.207,
  Os: 190.23,
  Ir: 192.217,
  Pt: 195.078,
  Au: 196.967,
  Hg: 200.59,
  Tl: 204.383,
  Pb: 207.2,
  Bi: 208.98,
  Po: 208.98,
  At: 209.987,
  Rn: 222.176,
  Fr: 223.019,
  Ra: 226.025,
  Ac: 227.028,
  Th: 232.038,
  Pa: 231.036,
  U: 238.029,
  Np: 237.048,
  Pu: 244.064,
  Am: 243.061,
  Cm: 247.07,
  Bk: 247.07,
  Cf: 251.08,
  Es: 252.083,
  Fm: 257.095,
  Md: 258.099,
  No: 259.101,
  Lr: 262.11,
  Rf: 267.12,
  Db: 268.13,
  Sg: 271.14,
  Bh: 270.14,
  Hs: 277.15,
  Mt: 278.16,
  Ds: 281.17,
  Rg: 281.17,
  Cn: 285.18,
  Nh: 286.19,
  Fl: 289.2,
  Mc: 289.2,
  Lv: 293.21,
  Ts: 294.22,
  Og: 294.22,
};
function MolecularWeightCalculator() {
  const [selectedElement, setSelectedElement] = useState("");
  const [quantity, setQuantity] = useState();
  const [compound, setCompound] = useState([]);
  const [result, setResult] = useState(0);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleAddElement = () => {
    if (selectedElement) {
      setCompound([...compound, { element: selectedElement, quantity }]);
      setSelectedElement("");
      setQuantity(1);
    }
  };
  const handleCalculate = () => {
    try {
      let totalWeight = 0;
      let calculationSteps = [];
      compound.forEach(({ element, quantity }) => {
        const elementWeight = ELEMENTS[element] * quantity;
        totalWeight += elementWeight;
        calculationSteps.push(
          `${quantity} × ${
            ELEMENTS[element]
          } (${element}) = ${elementWeight.toFixed(2)} جرام/مول`
        );
      });
      setResult(totalWeight);
      setSteps(calculationSteps);
      if (totalWeight === 0) {
        setError("يرجى اختيار عناصر من أجل القيام بعملية الحساب");
        return;
      }
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب الوزن الجزيئي لأي مركب كيميائي باستخدام
                  مجموع الأوزان الذرية للعناصر المكونة له.
                </p>
                <p>
                  <strong>
                    الوزن الجزيئي = مجموع الأوزان الذرية للعناصر المكونة للمركب
                  </strong>
                </p>
                <ul>
                  <li>اختر العنصر الكيميائي وعدد الذرات في المركب.</li>
                  <li>أضف العناصر المكونة للمركب لحساب الوزن الجزيئي الكلي.</li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب الوزن الجزيئي لأي مركب
                  كيميائي بدقة وسهولة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="element">
                        اختر العنصر الكيميائي
                      </label>
                      <select
                        id="element"
                        value={selectedElement}
                        onChange={(e) => setSelectedElement(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر العنصر</option>
                        {Object.keys(ELEMENTS).map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="quantity">
                        عدد الذرات
                      </label>
                      <input
                        id="quantity"
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleAddElement}
                    >
                      أضف العنصر
                    </button>
                    <br />
                    <ul>
                      {compound.map((item, index) => (
                        <li key={index}>
                          {item.quantity} × {item.element}
                        </li>
                      ))}
                    </ul>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result > 0 &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">{result.toFixed(2)} جرام/مول</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>الخطوات:</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هو الوزن الجزيئي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مفهوم الوزن الجزيئي</h2>
                  </u>
                  <p>
                    الوزن الجزيئي هو مجموع الأوزان الذرية لجميع الذرات التي
                    يتكون منها المركب الكيميائي.
                  </p>
                  <ul>
                    <li>
                      <strong>
                        الوزن الجزيئي = مجموع الأوزان الذرية للعناصر
                      </strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: الوزن الجزيئي للماء (H2O) = (2×1) + (16) = 18
                    جرام/مول.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيف نحسب الوزن الجزيئي؟
                    </h2>
                  </u>
                  <p>
                    لحساب الوزن الجزيئي لأي مركب كيميائي، اختر العناصر
                    الكيميائية وعدد ذرات كل عنصر.
                  </p>
                  <ul>
                    <li>
                      استخدم الجدول الدوري لاختيار الأوزان الذرية الصحيحة.
                    </li>
                    <li>
                      يمكنك استخدام حاسبتنا للقيام بالحسابات بشكل سهل ودقيق.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: حساب الوزن الجزيئي لثاني أكسيد الكربون (CO2).
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default MolecularWeightCalculator;
